export default function (el, htmlOptions) {
    $('#logbookPager').on('click', function (e) {
        e.preventDefault();

        let $firstHidden = $('#logbook').children('.entry').not('.u-hidden').last().next();

        $firstHidden.removeClass('u-hidden');

        if ($firstHidden.next('.u-hidden').length) {
            $firstHidden.next().removeClass('u-hidden');
        }

        if ($firstHidden.next().next().length) {
            $firstHidden.next().next().removeClass('u-hidden');
        }

        if ($firstHidden.prev().length) {
            $firstHidden.prev().addClass('u-hidden');
        }

        if ($firstHidden.prev().prev().length) {
            $firstHidden.prev().prev().addClass('u-hidden');
        }

        if ($firstHidden.prev().prev().prev().length) {
            $firstHidden.prev().prev().prev().addClass('u-hidden');
        }
    });
};
